module.exports = __webpack_public_path__ + "img/member_deals_card_image7.f74964b6.png";